import type { ChangeEvent } from 'react'

import React, { useState } from 'react'
import { SearchIcon, XIcon } from 'lucide-react'

import {
	InputBase,
	InputBaseAdornment,
	InputBaseAdornmentButton,
	InputBaseControl,
	InputBaseInput,
} from '@/shared/components/ui/input-base'
import { cn } from '@/shared/lib/utils'

type SearchFieldProps = {
	onChange?: (e: ChangeEvent<HTMLInputElement>) => void
	onValueChange: (value: string) => void
	className?: string
	placeholder?: string
	value: string
	compact?: boolean
	count?: number
}
export default function SearchField({
	onChange,
	onValueChange,
	className,
	placeholder,
	value,
	count,
	compact = false,
	...props
}: SearchFieldProps) {
	const [focused, setFocused] = useState(false)
	const handleFocus = () => setFocused(true)
	const handleBlur = () => setFocused(false)

	return (
		<InputBase
			className={cn(className, {
				'w-28': compact && !value && !focused,
			})}
		>
			<InputBaseAdornment>
				<SearchIcon />
			</InputBaseAdornment>
			<InputBaseControl>
				<InputBaseInput
					{...props}
					value={value}
					onChange={(e) => {
						onChange?.(e)
						onValueChange?.(e.target.value)
					}}
					onFocus={handleFocus}
					onBlur={handleBlur}
					placeholder={placeholder}
				/>
			</InputBaseControl>
			{!!value && (
				<InputBaseAdornment>{value && count ? count : null}</InputBaseAdornment>
			)}
			{!!value && (
				<InputBaseAdornmentButton onClick={() => onValueChange?.('')}>
					<XIcon />
				</InputBaseAdornmentButton>
			)}
		</InputBase>
	)
}
